export default __webpack_public_path__ + "static/media/480_store04-fr-web.836ff690.png";